"use client";
import { CommunityStatus } from "@prisma/client";
import React from "react";
import { Button } from "~/components/v4/themed/Button";

type Props = {
    status?: CommunityStatus;
};

const SubscribeToPublishHeader = ({ status }: Props) => {
    if (status !== CommunityStatus.PREVIEW) {
        return null;
    }
    return (
        <div className="sticky top-0 z-[100] flex flex-row items-center justify-between rounded-md bg-[#101114] px-4 py-3 text-white">
            <div className="flex w-[67%] flex-col">
                <span className="">Subscribe to publish your community</span>
                <span className="text-sm text-v3-N-300">
                    Unlock full access and start sharing your community with the
                    world.
                </span>
            </div>
            <div className="flex flex-row items-center gap-2">
                <Button
                    className="mb-2 h-max rounded py-2 md:w-full"
                    onClick={() => {
                        window.open(
                            "https://www.getriver.io/pricing",
                            "_blank",
                        );
                    }}
                >
                    Subscribe
                </Button>
            </div>
        </div>
    );
};

export default SubscribeToPublishHeader;
